module.exports = __webpack_public_path__ + "img/agree.f61e725.svg";